export default __webpack_public_path__ + "static/HomequizOlips-979cdd36061f638b10f1f76df6b336c6.png";